/**
 * O rodapé que diz DE ONDE veio o número.
 *
 * Um relatório que não diz a fonte é um relatório que pede fé. Aqui saem: o
 * schema e as tabelas lidas, a observação da fonte (ex.: "o Central ainda não
 * recebe pedido"), a chave usada para colapsar linha repetida em quantidade, e
 * o que a permissão do usuário mandou OMITIR.
 *
 * O bloco de omitidos é o §4 aparecendo na tela: mascarar é NÃO TRAZER do
 * servidor. A tela não escondeu nada — o campo não veio. Dizer isso é honesto
 * com quem olha e não tem a permissão: ele sabe que existe algo ali, e por quê.
 */
import React from "react";
import * as AlfredoStyles from "../../styles/components/reports/RelatorioComum";
import type { EnvelopeDeRelatorio } from "../../comum/relatorios/tipos";

interface Props {
  envelope: EnvelopeDeRelatorio;
}

const RodapeDaFonte: React.FC<Props> = ({ envelope }) => {
  const { fonte, paginacao, omitido } = envelope;

  return (
    <AlfredoStyles.Rodape>
      Fonte: <strong>{fonte.schema}</strong>
      {fonte.tabelas.length > 0 && <> — {fonte.tabelas.join(", ")}</>}. {fonte.observacao}
      {paginacao.total > 0 && (
        <>
          {" "}
          · {paginacao.total} linha(s), página {paginacao.pagina} de{" "}
          {paginacao.paginas}
        </>
      )}
      {omitido.length > 0 && (
        <>
          {" "}
          · Campos que sua permissão não alcança e que o servidor NÃO enviou:{" "}
          {omitido.join(", ")}.
        </>
      )}
    </AlfredoStyles.Rodape>
  );
};

export default RodapeDaFonte;
